import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MaterialsModule } from '@library/common/materials';

import { TrackerLineModule } from './tracker-line/tracker-line.module';
import { LoadingModule } from '@library/modules/loading';
import { PipesModule } from '@library/core/pipes';

import { ShipmentDetailsComponent } from './details.component';
import { AttachmentModule } from '@library/modules/attachment';
import { QuotationModule } from '@library/modules/quotation';

@NgModule({
   imports: [
      CommonModule,
      RouterModule,

      MaterialsModule,

      TrackerLineModule,
      LoadingModule,
      PipesModule,

      AttachmentModule,

      QuotationModule,
   ],
   declarations: [ ShipmentDetailsComponent ],
   exports: [ ShipmentDetailsComponent ],
   providers: [],
})
export class DetailsModule { }
